/**
 * @file ワンタイムパスワード入力フォームの状態を管理するステート
 *
 * パスワードリセットフローで、SMSで送信されたワンタイムパスワードと
 * ログインIDの入力値を保持する。
 * ワンタイムパスワード検証→パスワード再設定の画面遷移で値を引き継ぐため、
 * セッションストレージに永続化される。
 */
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** ワンタイムパスワードフォームの入力値型 */
type OnetimePasswordForm = {
  /** ワンタイムパスワード */
  onetimePassword: string;
  /** ログインID */
  loginId: string;
};
export type { OnetimePasswordForm };

const onetimePasswordFormState = atom<OnetimePasswordForm>({
  key: 'onetimePasswordFormState',
  default: {
    onetimePassword: '',
    loginId: '',
  },
  effects_UNSTABLE: [persistAtom],
});
export { onetimePasswordFormState };
